<style lang="scss">
.delete-dialog-card {
  padding: 20px;
  .headline {
    font-size: 14px !important;
    margin-bottom: 20px;
  }
  button {
    font-size: 14px;
    &.close-dialog {
      border: solid 1px #173d8f;
      color: #173d8f;
    }
    &.delete {
      background-color: #d9390d;
      background: #d9390d!important;
      color: #ffffff;
    }
  }
}
</style>

<template>
  <v-dialog v-model="deleteDialog" :max-width="maxWidth || 325">
    <v-toolbar class="toolbar-update" dense >
      <v-toolbar-title class="text-primary fs-15">
        <strong>{{$t('NOTIFICATION')}}</strong>
      </v-toolbar-title>
    </v-toolbar>
    <div class="content-update">
      <label class="s-label"><slot name="title" /></label>
      <div class="mt-3 d-flex justify-content-between">
        <div class="w-100 mr-1">
          <v-btn depressed block @click="close">
            {{ $t("_LOGIN.CANCEL") }}
          </v-btn>
        </div>
        <div class="w-100 ml-1">
          <v-btn block color="error" @click="deleteItem">
            {{ $t("DELETE") }}
          </v-btn>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  props: {
    maxWidth: Number
  },
  data() {
    return {
      deleteDialog: false,
      item: null
    };
  },
  methods: {
    open(item) {
      this.deleteDialog = true;
      this.item = item;
    },
    close() {
      this.deleteDialog = false;
    },
    deleteItem() {
      this.$emit("deleteItem", this.item);
      this.close();
    }
  }
};
</script>
